export enum DigitalServiceStatuses {
  NOT_ACTIVE ='NOT_ACTIVE',
  ACTIVE='ACTIVE',
  ACTIVE_LOCKED='ACTIVE_LOCKED',
  DEACTIVATION_PENDING='DEACTIVATION_PENDING',
  CHANGE_LOCKED='CHANGE_LOCKED',
  IN_CHANGE_PROCESS='IN_CHANGE_PROCESS',
  NOT_ACTIVE_LOCKED='NOT_ACTIVE_LOCKED',
}
